import React from "react";
import { useNavigate } from "react-router-dom";
import { useCategoriesInfiniteQuery } from "../../hooks/queries/useCategoriesInfiniteQuery";

/**
 * Subcategories of one parent, fetched only once the card is expanded.
 * Paginated and assigned-scoped, matching the parent grid.
 */
function CategoryChildren({ parentId }) {
  const navigate = useNavigate();

  const {
    categories: children,
    isLoading,
    error,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  } = useCategoriesInfiniteQuery({ assigned: true, parent: parentId });

  if (isLoading) {
    return (
      <div className="flex flex-wrap gap-1">
        {[...Array(3)].map((_, index) => (
          <div
            key={`child-skeleton-${index}`}
            className="h-5 w-16 bg-gray-200 animate-pulse rounded"
          />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <p className="text-xs text-red-500">Could not load subcategories</p>
    );
  }

  return (
    <div className="flex flex-wrap gap-1">
      {children.map((child) => (
        <button
          key={`child-${child.id}`}
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/search?Category=${child.slug}`);
          }}
          className="text-xs px-2 py-0.5 rounded transition-colors bg-brand-50 text-brand-700 hover:bg-brand-100 cursor-pointer"
          aria-label={`Browse ${child.name} subcategory`}
        >
          {child.name}
        </button>
      ))}
      {hasNextPage && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            fetchNextPage();
          }}
          disabled={isFetchingNextPage}
          className="text-xs px-2 py-0.5 rounded text-brand-600 hover:bg-brand-50 disabled:opacity-60"
        >
          {isFetchingNextPage ? "Loading…" : "More"}
        </button>
      )}
    </div>
  );
}

export default CategoryChildren;
